// src/services/dashboardService.ts
import apiClient from '../api/apiClient';

const TENANT_ID = process.env.REACT_APP_TENANT_ID ?? '1';
const SUMMARY_PATH = '/admin/dashboard/summary';

/**
 * Calls GET {baseURL}/admin/dashboard/summary?tenantId={TENANT_ID}
 * Returns a normalized record of numbers: { students: number, videos: number, ... }
 */
export async function getDashboardSummary(): Promise<Record<string, number>> {
    const url = `${SUMMARY_PATH}?tenantId=${TENANT_ID}`;
    try {
        const resp = await apiClient.get(url);
        console.log('[dashboardService] summary resp status =', resp.status);
        console.log('[dashboardService] summary resp data =', resp.data);
        const json = resp?.data ?? {};
        if (!json || typeof json !== 'object') {
            throw new Error('Invalid summary response');
        }
        const stats: Record<string, number> = {};
        for (const [k, v] of Object.entries(json)) {
            stats[k] = Number((v as any) ?? 0) || 0;
        }
        return stats;
    } catch (err: any) {
        console.error('[dashboardService] summary error ->', err?.response?.data ?? err?.message ?? err);
        const serverMessage = err?.response?.data?.message ?? err?.message;
        const e = new Error(`Failed to fetch dashboard summary${serverMessage ? `: ${serverMessage}` : ''}`);
        (e as any).original = err;
        throw e;
    }
}

